import { Fragment } from 'react'
import { PayByGatewayProps } from './pay-by-gateway.types'
import { Box } from '@vapor/material'
import { TSPayLink2Pay } from 'src/app/components/ts-pay/link2pay'

export const PayByGateway = (props: PayByGatewayProps) => {
  const { dataForGatewayPayment, tsPayInfo, propertyId, onLoading } = props
  const { paymentDescription, cashDeskTypeId, customerId, customerEmail, reservationId, onPaymentConfirmed } = tsPayInfo

  return (
    <>
      {dataForGatewayPayment?.paymentActivesWithGateway?.paymentActives.map((paymentActiveWithGateway, index) => {
        const gatewayOfPaymentActive =
          paymentActiveWithGateway.paymentMethods?.length && paymentActiveWithGateway.paymentMethods?.length > 0 ? paymentActiveWithGateway.paymentMethods[0].gateway : undefined
        switch (gatewayOfPaymentActive?.type) {
          case 'TSPAY': {
            return (
              <Fragment key={index}>
                <Box sx={{ m: 1, mt: 2 }} width="100%">
                  <TSPayLink2Pay
                    amount={dataForGatewayPayment.amount}
                    cashDeskTypeId={cashDeskTypeId}
                    paymentDescripton={paymentDescription}
                    customerId={customerId}
                    reservationId={reservationId}
                    customerEmail={customerEmail}
                    propertyId={propertyId}
                    onLoading={onLoading}
                    onPaymentConfirmed={(success) => onPaymentConfirmed(success, paymentActiveWithGateway.id)}
                  />
                </Box>
              </Fragment>
            )
          }
          case 'PAYPAL': {
            return <Fragment key={index}>NOT YET IMPLEMENTED</Fragment>
          }
        }
      })}
    </>
  )
}
